import type { UserState, Countries, Langs } from '@/redux/user/types';
import { MCD } from '@/services/app';
import Store from '@/redux';

import {
  setUserData,
  setUserPoints,
  setUserCountry,
  setUserLanguage
} from '@/redux/user/actions';

export const checkUserData = async () => {
  try {
    const userInfo = (await MCD.getUserData()) as UserState;
    Store.dispatch(setUserData(userInfo));
  } catch (error) {
    console.error('"checkUserData" error:', error);
    throw error;
  }
};

export const checkUserPoints = async () => {
  try {
    const userPoints = await MCD.getUserPoints();
    Store.dispatch(setUserPoints(userPoints));
  } catch (error) {
    console.error('"checkUserPoints" error:', error);
    throw error;
  }
};

export const checkUserCountry = async () => {
  try {
    const userCountry = (
      await MCD.getUserCountry()
    ).toLocaleLowerCase() as Countries;

    Store.dispatch(setUserCountry(userCountry));
  } catch (error) {
    console.error('"checkUserCountry" error:', error);
    throw error;
  }
};

export const checkUserLanguage = async () => {
  try {
    const userLanguage = (
      await MCD.getUserLanguage()
    ).toLocaleLowerCase() as Langs;

    const countrySeparator = userLanguage.indexOf('-');
    const end = countrySeparator > -1 && countrySeparator;
    const language = userLanguage.slice(0, end || undefined);

    Store.dispatch(setUserLanguage(language));
  } catch (error) {
    console.error('"checkUserLanguage" error:', error);
    throw error;
  }
};
